import { getLobType } from "../../../../actions/Utilities/LobType";
import { useQuery } from "react-query";

export const useGetLobTypeOptions = () => {
  return useQuery("LOBOptionsProducerCode", getLobType, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
